module.exports = __webpack_public_path__ + "img/eye.0e410f2.svg";